import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

 const getRawVal = (suggestObject, query, field) => {
        if (Array.isArray(suggestObject._source[field])) {
            return suggestObject._source[field].find(x=>x.toLowerCase().includes(query))
        }
        return suggestObject._source[field]

    }
    

export default function Asynchronous({setTags}) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
const [searchTxt, setsearchTxt] = React.useState('');
const [selected, setSelected] = React.useState({name: ''});
  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
        
      if (active) {
        if(searchTxt && searchTxt.length > 2) {
                    let url = `/api/suggestions?field=tag&query=${searchTxt?searchTxt.toLowerCase():''}`;
                    const response = await fetch(url);
                    const suggestions = await response.json();
                    let results = [];
                    const {hits:{hits}} = suggestions;
                    results = hits.map(x=> {
                        const match =  Object.keys(x.highlight).length ? Object.keys(x.highlight)[0] : null;
                        if (match) {
                            return {name:x.highlight[match][0], type:'tags', raw:getRawVal(x, searchTxt.toLowerCase(), 'tags')}
                        }
                    })
                    var setObj = new Set(); // create key value pair from array of array
                    results = results.reduce((acc,item)=>{
                        if(!setObj.has(item.name)){
                        setObj.add(item.name,item)
                        acc.push(item)
                        }
                        return acc;
                    },[])
            
                    if (active) {
                        setOptions(results)
                    }
                }
      }
    })();

    return () => {
      active = false;
    };
  }, [searchTxt]);

        const onInputChange = () => {
    return (event, value, reason)=> {
            if (reason !=="reset") {
                setsearchTxt(value )

            } else {
            }
            setOptions([]);
          }
      }
const onChange = (searchTxt)=> {
        return (e, v, r) => {
            v = v.map(val=>{
                if (typeof(val) === "string") {
                    return {raw:val, name: val}
                }
                return val
            })
           setSelected(v)
           setTags(v)
            
                       
           /* v = v || '';
            let keyword = v.name ? v.name.toLowerCase() : v;
            setSelected({name:keyword})
            console.log('keyword', keyword)
            updateState(props.field, keyword)
            updateState('from', 0)
            if (props.closeOnSelect) {
                props.setAnchor(null);
            }
            if (props.redirectOnSelect) {
                navigate('/'); 
            }*/
        }
    }
  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      id="asynchronous-demo"
      multiple
      freeSolo
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
          setOptions([]);
      }}
      isOptionEqualToValue={(option, value) => {  return option.name === value.name || option === value.name}}
      getOptionLabel={(option) => {console.log(option); return option.raw ? option.raw : option}}
      options={options}
      loading={loading}
      onInputChange={onInputChange()}
      onChange={onChange()}
      renderOption={(props,option) => (<li {...props}><div dangerouslySetInnerHTML={{__html: `${option.name}`}}/></li>)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Asynchronous"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}


